<template>
  <div>
    <b-row>
      <b-col>
        <b-row
          class="content-header"
        >
          <b-col
            class="content-header-left mb-2"
            cols="12"
            md="9"
          >
            <b-row class="breadcrumbs-top">
              <b-col cols="12">
                <h2 class="content-header-title float-left pr-1 mb-0">
                  {{ course.title }}
                </h2>
                <div class="breadcrumb-wrapper">
                  <b-breadcrumb>
                    <b-breadcrumb-item
                      :to="{ name: 'dashboard-mechtech' }"
                    >
                      <feather-icon
                        icon="HomeIcon"
                        size="16"
                        class="align-text-top"
                      />
                    </b-breadcrumb-item>
                    <b-breadcrumb-item
                      :to="{ name: 'courses' }"
                    >
                      Course List
                    </b-breadcrumb-item>
                    <b-breadcrumb-item
                      :active="true"
                    >
                      {{ course.title }}
                    </b-breadcrumb-item>
                  </b-breadcrumb>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8">
        <b-card no-body>
          <b-card-header>
            <span class="d-flex align-items-center">
              <feather-icon
                icon="FileTextIcon"
                size="17"
                class="text-body mr-1 align-self-center"
                stroke="#990000"
              />
              <h3 class="mb-0">Tentang Kelas</h3>
            </span>
          </b-card-header>

          <b-card-body>
            <div v-html="course.long_description" />
          </b-card-body>
        </b-card>

        <b-card no-body>
          <b-card-header>
            <span class="d-flex align-items-center">
              <feather-icon
                icon="BookOpenIcon"
                size="17"
                class="text-body mr-1 align-self-center"
                stroke="#990000"
              />
              <h3 class="mb-0">Materi Kelas</h3>
            </span>
          </b-card-header>

          <b-card-body>
            <b-row>
              <b-col>
                <span>Berikut adalah materi - materi yang akan kamu pelajari dalam course ini:</span>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col>
                <div class="accordion" role="tablist">
                  <b-card no-body class="mb-1 p-0">
                    <b-card-header header-tag="header" class="p-0" role="tab">
                      <a v-b-toggle.accordion-1 class="w-100">
                        <b-row>
                          <b-col md="10">
                            <h5>Module Pertama</h5>
                          </b-col>
                          <b-col md="2" class="d-flex justify-content-end">
                            <feather-icon
                              size="32"
                              icon="ChevronDownIcon"
                              class="mr-50"
                            />
                          </b-col>
                        </b-row>
                      </a>
                    </b-card-header>
                    <b-collapse
                      id="accordion-1"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body class="p-0 mt-1">
                        <b-row>
                          <b-col>
                            <ul class="list-group">
                              <li class="list-group-item">Subjek 1</li>
                              <li class="list-group-item">Subjek 2</li>
                              <li class="list-group-item">Subjek 3</li>
                              <li class="list-group-item">Assignment</li>
                            </ul>
                          </b-col>
                        </b-row>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <b-card no-body>
          <b-card-header>
            <span class="d-flex align-items-center">
              <feather-icon
                icon="UserIcon"
                size="17"
                class="text-body mr-1 align-self-center"
                stroke="#990000"
              />
              <h3 class="mb-0">Mentor</h3>
            </span>
          </b-card-header>

          <b-card-body>
            <b-row>
              <b-col md="4" class="d-flex justify-content-center">
                <b-img :src="defaultThumbnailMentor" alt="Card cap" class="card-img-top w-75" rounded="circle" />
              </b-col>
              <b-col md="8">
                <h4>{{ mentor.name }}</h4>
                <p class="mt-2">{{ mentor.bio }}</p>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-row>
          <b-col class="d-flex justify-content-center w-75">
            <b-card>
              <b-img :src="defaultThumbnail" alt="Card cap" class="card-img-top" />
              <b-card-body class="p-1">
                <b-card-title class="mb-2">Dapatkan akses kelas dengan berlangganan</b-card-title>
                <b-card-text>
                  <b-row>
                    <b-col>
                      <span>Yang akan kamu dapatkan:</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <span class="d-flex align-items-center"><b-img :src="checkBoxIcon" class="mr-1 check-box-icon" />Akses penuh video kelas</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <span class="d-flex align-items-center"><b-img :src="checkBoxIcon" class="mr-1 check-box-icon" />Modul pembelajaran yang komprehensif</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <span class="d-flex align-items-center"><b-img :src="checkBoxIcon" class="mr-1 check-box-icon" />Ujian untuk memvalidasi pengetahuan</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <span class="d-flex align-items-center"><b-img :src="checkBoxIcon" class="mr-1 check-box-icon" />Tugas praktik</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <span class="d-flex align-items-center"><b-img :src="checkBoxIcon" class="mr-1 check-box-icon" />Sertifikat pengakuan kompetensi</span>
                    </b-col>
                  </b-row>
                </b-card-text>
                <b-button
                  block
                  class="mt-2"
                  variant="primary"
                  :to="{ name: 'subscriptions' }"
                >
                  Mulai Berlangganan
                </b-button>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: "CourseDetail",
  components: {},
  data() {
    return {
      course: {
        title: "Course 1",
        slug: "course-1",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vel fringilla mauris, eu interdum ligula. Fusce feugiat massa nec justo pulvinar, non tincidunt nisi viverra. In hac habitasse platea dictumst",
        price_regular: 500000,
        price_actual: 250000,
        application_name: "solidworks",
        thumbnail: "https://mechtechidn.com/wp-content/uploads/2021/09/Screenshot-2021-09-24-at-13.03.48-150x150.png",
        long_description:`
          <h5>Deskripsi Kelas</h5>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          <h5>Tujuan Kelas</h5>
          <ul>
            <li>Tujuan 1</li>
          </ul>
        `
      },
      mentor: {
        name: "Nama Mentor",
        bio: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vel fringilla mauris, eu interdum ligula. Fusce feugiat massa nec justo pulvinar, non tincidunt nisi viverra. In hac habitasse platea dictumst",
        thumbnail: "https://mechtechidn.com/wp-content/uploads/2021/09/Screenshot-2021-09-24-at-13.03.48-150x150.png"
      },
      checkBoxIcon: require('@/assets/images/mechtech/check-box-icon.png'),
      defaultThumbnail: require('@/assets/images/logo/logo-icon.png'),
      defaultThumbnailMentor: require('@/assets/images/mechtech/default-thumbnail/user-thumbnail.png'),
    };
  },
  methods: {
    formatToRupiah(value) {
      const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
      });

      return formatter.format(value);
    }
  }
};
</script>

<style scoped>
.feather > .card-icons {
  stroke: #990000 !important;
}
.check-box-icon {
  height: 18px;
}
</style>
